"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleTop = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var DesktopTop_1 = require("./DesktopTop");
var TabletTop_1 = require("./TabletTop");
var MobileTop_1 = require("./MobileTop");
var BubbleTop = function () {
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var getTopBubbles = function (breakpoint) {
        switch (breakpoint) {
            case 'xs':
                return react_1.default.createElement(MobileTop_1.MobileTop, null);
            case 'sm':
                return react_1.default.createElement(TabletTop_1.TabletTop, null);
            case 'md':
            case 'lg':
                return react_1.default.createElement(DesktopTop_1.DesktopTop, null);
            default:
                return react_1.default.createElement(DesktopTop_1.DesktopTop, null);
        }
    };
    return (react_1.default.createElement(asg_1.FlexGrid, { direction: "column", wrap: "nowrap", alignItems: "center", margin: "none", "data-testid": "bubbles-top" },
        react_1.default.createElement(asg_1.Box, { style: {
                overflow: 'none',
                alignItems: 'center',
                overflowX: 'hidden',
            } }, getTopBubbles(responsiveSize))));
};
exports.BubbleTop = BubbleTop;
//# sourceMappingURL=BubblesTop.js.map